import { render } from "./WarnSvg.vue?vue&type=template&id=14f843d0&bindings={}"
import script from "./WarnSvg.vue?vue&type=script&lang=ts"
export * from "./WarnSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script